import { defaultHttpClient } from '../../httpClient';
import type { GetIconsAllResponse } from './types';

/**
 * - 카테고리 탭 상단 아이콘 > 전체보기(전체메뉴) 조회 API
 */
export const getIconsAll = () => {
  return defaultHttpClient
    .request<GetIconsAllResponse>({
      method: 'GET',
      url: '/api/v2/overview/icons/all',
    })
    .then(result => result.data);
};
